import { i18n } from 'LibNeo'

export const isErrorBizon = (res) => {
	let error = null
	const errorCode = Object.keys(res?.data?.errors?.[0])?.[0]
	if (errorCode.includes('attempts_block_for_')) {
		error = i18n(`errors.${errorCode}`)
	}
	return error
}
